import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { electricityPurchasedColumns, electricityPurchasedGrandTotalFields, electricityPurchasedTotalColumns, renewableEnergyProducedColumns, renewableEnergyPurchasedGrandTotalFields, renewableEnergyPurchasedTotalsColumn } from '../constants/category-two-columns';
import { getElectricityPurchasedData, getElectricityPurchasedDataTotals, postElectricityPurchasedData } from '../../../../../actions/carbonfootprint-rework/02-indirect-ghg-emissions-from-imported-energy/01-electricity-purchased-actions';
import { getRenewableEnergyData, getRenewableEnergyDataTotals, postRenewableEnergyData } from '../../../../../actions/carbonfootprint-rework/02-indirect-ghg-emissions-from-imported-energy/02-renewable-energy-produced-actions';
import useTsPaginator from 'ts-paginator';
import { MONTHMAPPER } from '../constants/months';
import { uploadCsvDocument } from '../../../../../actions/carbonfootprint-rework/00-base/00-base-actions';


export function useCategoryTwoDataStore(selectedCategory, year, company, group, facility) {
    const dispatch = useDispatch();
    const [month, setMonth] = useState(0);

    // --- declare useSelector variables ---
    const electricityPurchasedData = useSelector(state => state.directGhgEmissionsAndRemovalsForElectricityPurchased.electricityPurchasedData?.data)
    const electricityPurchasedTableRecords = useSelector(state => state.directGhgEmissionsAndRemovalsForElectricityPurchased.electricityPurchasedData?.pagination?.total_records)
    const electricityPurchasedTotals = useSelector(state => state.directGhgEmissionsAndRemovalsForElectricityPurchased.electricityPurchasedDataTotals?.data)
    const renewableEnergyProducedData = useSelector(state => state.directGhgEmissionsAndRemovalsForRenewableEnergy.renewableEnergyData?.data)
    const renewableEnergyProducedTableRecords = useSelector(state => state.directGhgEmissionsAndRemovalsForRenewableEnergy.renewableEnergyData?.pagination?.total_records)
    const renewableEnergyProducedTotals = useSelector(state => state.directGhgEmissionsAndRemovalsForRenewableEnergy.renewableEnergyDataTotals?.data)

    // --- variable manipulation, to make hook call cleaner ---

    const selectedCategoryDataMap = {
        'Electricity Purchased': {
            data: electricityPurchasedData,
            totals: electricityPurchasedTotals,
            getDataAction: getElectricityPurchasedData,
            getTotalsAction: getElectricityPurchasedDataTotals,
            postDataAction: postElectricityPurchasedData,
            categoryKey: 'electricity-purchased',
            columns: electricityPurchasedColumns,
            totalColumns: electricityPurchasedTotalColumns,
            grandTotalFields: electricityPurchasedGrandTotalFields,
            tableRecordCount: electricityPurchasedTableRecords,
        },
        'Renewable Energy Produced': {
            data: renewableEnergyProducedData,
            totals: renewableEnergyProducedTotals,
            getDataAction: getRenewableEnergyData,
            getTotalsAction: getRenewableEnergyDataTotals,
            postDataAction: postRenewableEnergyData,
            categoryKey: 'renewable-energy-produced',
            columns: renewableEnergyProducedColumns,
            totalColumns: renewableEnergyPurchasedTotalsColumn,
            grandTotalFields: renewableEnergyPurchasedGrandTotalFields,
            tableRecordCount: renewableEnergyProducedTableRecords,
        },
    }

    const {
        data,
        totals,
        getDataAction,
        getTotalsAction,
        postDataAction,
        categoryKey,
        columns,
        totalColumns,
        grandTotalFields,
        tableRecordCount
    } = selectedCategoryDataMap[selectedCategory] ||
        {
            data: null,
            totals: null,
            getDataAction: null,
            getTotalsAction: null,
            postDataAction: null,
            categoryKey: null,
            columns: [],
            totalColumns: [],
            grandTotalFields: [],
            tableRecordCount: 0
        };

    const {
        totalRecordCount,
        rowsPerPage,
        currentPage,
        _determinePaginationMessage,
        _determinePaginationDisabledState,
        // _determinePaginationPages,
        _determineRowsPerPageOptions,
        _handleChangeTotalRecordCount,
        _handleChangeRowsPerPage,
        _handleChangePage,
    } = useTsPaginator(+tableRecordCount || 0, 0);

    useEffect(() => {
        // if (currentProjectId !== projectId) {
        _handleChangePage(0); // Reset to the first page
        _handleChangeRowsPerPage(10)
        _handleChangeTotalRecordCount(+tableRecordCount); // Reset to the first page
        // }
    }, [tableRecordCount]);

    useEffect(() => {
        const monthForBackend = MONTHMAPPER[month];
        if (selectedCategory === 'Electricity Purchased') {
            dispatch(getElectricityPurchasedData(year, facility, rowsPerPage, currentPage, monthForBackend))
        }
        if (selectedCategory === 'Renewable Energy Produced') {
            dispatch(getRenewableEnergyData(year, facility, rowsPerPage, currentPage, monthForBackend))
        }

    }, [dispatch, selectedCategory, year, facility, group, company, rowsPerPage, currentPage]
    )

    return {
        month,
        setMonth,
        data,
        totals,
        getDataAction,
        getTotalsAction,
        postDataAction,
        uploadCsvDocument,
        categoryKey,
        columns,
        totalColumns,
        grandTotalFields,
        year,
        facility,
        group,
        company,
        // pagination
        totalRecordCount,
        rowsPerPage,
        currentPage,
        _determinePaginationMessage,
        _determinePaginationDisabledState,
        // _determinePaginationPages,
        _determineRowsPerPageOptions,
        _handleChangeTotalRecordCount,
        _handleChangeRowsPerPage,
        _handleChangePage,
    }
}